/* eslint-disable no-nested-ternary */
import React from 'react';
import Async from 'react-select/async';
import {ReactComponent as MenuArrow} from 'assets/svgs/actions/arrow-drop.svg';

import Select, {components} from 'react-select';
import {FormGroup, Label} from 'reactstrap';
import './select.scss';

const getOption = (value, options, isMulti) => {
  if (isMulti) {
    return options.filter(
      (option) => value.includes(option.value) || value.includes(option._id)
    );
  }
  return options.find(
    (option) => option.value === value || option._id === value
  );
};

const getSelectedValue = (isAsync, isMulti, options, value) => {
  if (isAsync) {
    if (value && Object.keys(value).length) {
      if (value) return value;
      return null;
    }
    return null;
  }
  if (value) {
    return getOption(value, options, isMulti);
  }
  return null;
};

const CustomSelect = ({
  width,
  size,
  value,
  options,
  onChange,
  style,
  placeholder,
  isMulti,
  className,
  label,
  labelSmall,
  selectClassName,
  classNamePrefix,
  isAsync,
  isCreatable,
  onCreateOption,
  horizontal,
  loadOptions,
  getOptionLabel,
  getOptionValue,
  isClearable,
  isDisabled,
  error,
  backgroundColor,
  textColor,
  ...rest
}) => {
  const selected = getSelectedValue(isAsync, isMulti, options, value);
  const Tag = isAsync ? Async : Select;

  return (
    <FormGroup
      className={`${className || ''} ${
        horizontal ? 'form-group--horizontal' : ''
      }`}
      style={{width: width || 'auto'}}
    >
      {label && (
        <Label className="form-label">
          {label}
          {labelSmall && <small>{labelSmall}</small>}
        </Label>
      )}
      <Tag
        size={size}
        value={selected}
        options={options}
        autoFocus={false}
        onChange={(opt) => {
          const getValue = () =>
            opt ? (isAsync ? opt : opt.value ? opt.value : opt._id) : null;

          const current = isMulti ? opt.map(getValue) : getValue(opt);
          onChange(current);
        }}
        styles={styles(width, size, backgroundColor, textColor)}
        components={{DropdownIndicator}}
        placeholder={placeholder}
        className={`react-select ${selectClassName || ''} ${
          isDisabled ? 'disabled' : ''
        }`}
        classNamePrefix="react-select"
        isMulti={isMulti || false}
        loadOptions={isAsync ? loadOptions : null}
        getOptionLabel={getOptionLabel || ((option) => option.label)}
        getOptionValue={getOptionValue || ((option) => option.value)}
        isClearable={isClearable}
        isDisabled={isDisabled || false}
        onCreateOption={isCreatable && onCreateOption ? onCreateOption : null}
        {...rest}
      />
    </FormGroup>
  );
};
export default CustomSelect;

export const styles = (width, size, background, color) => ({
  container: (base) => ({
    ...base,
    width: width || '100%',
  }),
  control: () => ({
    display: 'flex',
    borderRadius: 1,
    minHeight: '2rem',
    backgroundColor: background || undefined,
    color: color || undefined,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: size === 'large' ? 12 : 10,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  singleValue: (base) => ({
    ...base,
    color: color || undefined,
  }),
});

export const DropdownIndicator = (props) => {
  const {menuIsOpen, size} = props.selectProps;
  return (
    components.DropdownIndicator && (
      <div className={menuIsOpen ? 'menu-is-open' : ''}>
        <components.DropdownIndicator {...props}>
          <MenuArrow open={menuIsOpen} size={size === 'large' ? 24 : 20} />
        </components.DropdownIndicator>
      </div>
    )
  );
};
